import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { ServiceValues } from '../../values/ServiceValues';
import { ServiceAxios } from '../../services/ServiceEW';
import EstoqueInsumoMovimentacaoTable from './components/EstoqueInsumoMovimentacaoTable';
import EstoqueInsumoMovimentacaoToolbar
  from './components/EstoqueInsumoMovimentacaoToolbar/EstoqueInsumoMovimentacaoToolbar';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import { NotFound as NotFoundView } from '../index';
import { MessageValues } from '../../values/MessageValues';
import { isAuthenticated } from '../../helpers/authenticate';
import { Grid, TextField } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import {
  getEstoqueInsumoMovimentacaoFiltrado,
  getEstoqueInsumoMovimentacaoFiltradoPorInsumo, getEstoqueInsumoMovimentacaoFiltradoPorInsumoComMovimentacoes,
  getEstoqueInsumoMovimentacaoMetadadosFiltrado
} from '../../services/EstoqueInsumoMovimentacaoService';
import { Values } from '../../values/Values';
import { getAllInsumos } from '../../services/InsumoService';
import Alert from '@material-ui/lab/Alert/Alert';
import Autocomplete from '@material-ui/lab/Autocomplete/Autocomplete';
import BottomScrollListener from 'react-bottom-scroll-listener';
import clsx from 'clsx';
import CardAnaliseGeral from './components/CardAnaliseGeral/CardAnaliseGeral';
import CardAnalisePorInsumo from './components/CardAnalisePorInsumo/CardAnalisePorInsumo';
import CardAnaliseEstatistica from './components/CardAnaliseEstatística/CardAnaliseEstatistica';
import Divider from '@material-ui/core/Divider';
import moment from 'moment';
import DialogAnaliseGeral from './components/DialogAnaliseGeral/DialogAnaliseGeral';
import DialogAnalisePorInsumo from './components/DialogAnalisePorInsumo/DialogAnalisePorInsumo';
import DialogAnaliseEstatistica from './components/DialogAnaliseEstatistica/DialogAnaliseEstatistica';


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    margin: theme.spacing(2)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  pagination: {
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  divFab:{
    zIndex: 2
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  margem: {
    marginRight: 25,
    marginLeft: 25,
    marginBottom: 35
  }
}));

function EstoqueInsumoMovimentacaoList({history}) {
  const timeout = ServiceValues.timeout;
  const baseUrl = ServiceValues.base_url_local;
  const api = ServiceAxios(baseUrl, timeout);
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [movimentacoes, setMovimentacoes] = useState({
    result: []
  });
  const [insumos, setInsumos] = useState({
    result: []
  });
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  const [showDialogConfirmacaoDeleteMovimentacoe, setShowDialogConfirmacaoDeleteMovimentacoe] = useState(false);
  const [showDialogAtualizarEstoque, setShowDialogAtualizarEstoque] = useState(false);
  const [selectedIndexMovimentacoe, setSelectedIndexMovimentacoe] = useState(-1);
  const [cnpjConfirmation, setCnpjConfirmation] = useState('');
  const [sucess, setSucess] = useState(true);
  const [openMovimentacoeChangePassword, setOpenMovimentacoeChangePassword] = useState(false);
  const [quantidadeMovimentacao, setQuantidadeMovimentacao] = useState(0);
  const [radioGroupValue, setRadioGroupValue] = React.useState('entrada');
  const [resfreshState, setRefreshState] = useState(new Date());
  const [insumoSelecionado, setInsumoSelecionado] = useState();
  let [page, setPage] = useState(1);
  let [fimLista, setFimLista] = useState(false);
  const [filtroAtivo, setFiltroAtivo] = useState(false);
  const [filtroDescricaoInsumo, setFiltroDescricaoInsumo] = useState('');
  const [insumosFiltrosSelecionados, setInsumosFiltrosSelecionados] = useState([]);
  const [filtroTipoMovimentacaoSelecionado, setFiltroTipoMovimentacaoSelecionado] = useState();
  const [filtroDataInicial, setFiltroDataInicial] = useState(moment(new Date()).startOf('week'));
  const [filtroDataFinal, setFiltroDataFinal] = useState(moment(new Date()).endOf('week'));
  const [metadados, setMetadados] = useState({
    qtdMovimentacoes: 0,
    qtdInsumosMovimentados: 0
  });
  const [openDialogAnaliseGeral, setOpenDialogAnaliseGeral] = useState(false);
  const [infoAnaliseDetalhada, setInfoAnaliseDetalhada] = useState();
  const [infoAnaliseResumida, setInfoAnaliseResumida] = useState();
  const [openDialogAnaliseResumida, setOpenDialogAnaliseResumida] = useState(false);
  const [infoAnaliseEstatistica, setInfoAnaliseEstatistica] = useState();
  const [openDialogAnaliseEstatistica, setOpenDialogAnaliseEstatistica] = useState(false);


  useEffect(() => {
    function checkAuth() {
      isAuthenticated(history);
    }
    checkAuth();
  }, []);

  useEffect(() => {
    carregarMovimentacoesHoje();
    getInsumos();
    carregarMovimentacoesMetadadosFiltrado()
  }, []);


  async function carregarMovimentacoesHoje() {
    try{
      setLoading(true);
      const dados = await getEstoqueInsumoMovimentacaoFiltrado(Values.limiteRegistroLista, page, undefined, undefined, new Date(), new Date(), undefined);
      setLoading(false);
      if(dados.isSuccess){
        page = page + 1
        setPage(page);
        if(dados.result.length !== 0){
          dados.result.map(mov => {
            movimentacoes.result.push(mov)
          });
          setMovimentacoes(movimentacoes);
          setRefreshState(new Date());
        }
        else{
          if(page === 1){
            setLoading(false);
            setTypeSnack('warning');
            setMessageSnack('Não há movimentações.');
            setShowMessageSnack(true);
          }
          else{
            setFimLista(true);
          }

        }
      }
      else{
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(dados.message);
        setShowMessageSnack(true);
      }

    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);

    }
  }

  async function carregarMovimentacoesFiltrado() {
    try{
      setLoading(true);
      const dados = await getEstoqueInsumoMovimentacaoFiltrado(Values.limiteRegistroLista, 1, filtroDescricaoInsumo, );
      setLoading(false);
      if(dados.isSuccess){
        setPage(page + 1);
        if(dados.result.length !== 0){
          let result = [];

          dados.result.map(mov => {
            result.push(mov)
          });
          setMovimentacoes({result: result});
          setRefreshState(new Date());
        }
        else{
          if(page === 1){
            setLoading(false);
            setTypeSnack('warning');
            setMessageSnack('Não há movimentações.');
            setShowMessageSnack(true);
          }
          else{
            setFimLista(true);
          }

        }
      }
      else{
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(dados.message);
        setShowMessageSnack(true);
      }

    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);

    }
  }

  async function carregarMovimentacoesMetadadosFiltrado() {
    try{
      setLoading(true);
      let insumos = [];
      insumosFiltrosSelecionados.map(insumo => {
        insumos.push(insumo.idInsumo);
      });
      const dados = await getEstoqueInsumoMovimentacaoMetadadosFiltrado(undefined, insumos, new Date(filtroDataInicial), new Date(filtroDataFinal), filtroTipoMovimentacaoSelecionado);
      setLoading(false);
      if(dados.isSuccess){
        setMetadados(dados.result);
      }
      else{
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(dados.message);
        setShowMessageSnack(true);
      }

    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);

    }
  }

  async function getInsumos() {
    try{
      setLoading(true);
      let insumos1 = await getAllInsumos(1000, 1);
      if(insumos1.isSuccess){
        setLoading(false);
        setInsumos(insumos1);
      }
      else{
        setLoading(false);
        setTypeSnack('warning');
        setMessageSnack(insumos1.message);
        setShowMessageSnack(true);
      }
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  const handleChange = (event) => {
    setRadioGroupValue(event.target.value);
    setRefreshState(new Date());
  };

  async function atualizarEstoqueMovimentacoe(){
    if(!insumoSelecionado){
      setMessageSnack('Selecione um insumo');
      setTypeSnack('error');
      setShowMessageSnack(true);
      return;
    }
    try{
      setLoading(true);
      setShowDialogAtualizarEstoque(false);
      let novaQuantidadeMovimentacoe = quantidadeMovimentacao;
      let tipoMovimentacao = '';
      if(radioGroupValue === 'entrada'){
        tipoMovimentacao = 'P';
        if(quantidadeMovimentacao < 0){
          novaQuantidadeMovimentacoe = parseInt(quantidadeMovimentacao*-1);
        }
      }
      else{
        tipoMovimentacao = 'N';
        if(quantidadeMovimentacao > 0){
          novaQuantidadeMovimentacoe = parseInt(quantidadeMovimentacao*-1);
        }
      }
      const auth = JSON.parse(localStorage.getItem('auth'));
      const movimentacoe_put = {
        quantidade: novaQuantidadeMovimentacoe,
        tipoMovimentacao: tipoMovimentacao,
        idUsuario: auth.result.idUsuario
      };
      const dados = await api.put('insumos/estoque/'+ insumoSelecionado.estoqueInsumo.idEstoqueInsumo, movimentacoe_put);
      if(dados){
        if(dados.data.isSuccess){
          setMessageSnack(dados.data.message);
          setTypeSnack('success');
          setShowMessageSnack(true);
          setShowDialogAtualizarEstoque(false);
          page = 0;
          setPage(page);
          fimLista = false;
          setFimLista(fimLista);
          await carregarMovimentacoesHoje();
          await carregarMovimentacoesMetadadosFiltrado();
          setInsumoSelecionado(null);
          setQuantidadeMovimentacao(0);
        }
        else{
          setMessageSnack(dados.data.message);
          setTypeSnack('error');
          setShowMessageSnack(true);
          setInsumoSelecionado(null);
          setShowDialogAtualizarEstoque(false);
        }
        setLoading(false);
      }
      else{
        setLoading(false);
        setMessageSnack(MessageValues.erro_catch);
        setTypeSnack('error');
        setShowMessageSnack(true);
        setInsumoSelecionado(null);
        setShowDialogAtualizarEstoque(false);
      }
    }
    catch (e) {
      setLoading(false);
      setInsumoSelecionado(null);
      setTypeSnack('error');
      setMessageSnack(MessageValues.erro_catch + ' Detalhamento erro: ' + e.toString());
      setShowMessageSnack(true);
    }
  }

  function onCancelAtualizarEstoque(){
    setSelectedIndexMovimentacoe(-1);
    setInsumoSelecionado(null);
    setShowDialogAtualizarEstoque(false);
  }

  async function openMovimentacoeRegister() {
    await getInsumos();
    setShowDialogAtualizarEstoque(true);
  }

  function handleChangeInsumo(event, insumo) {
   setInsumoSelecionado(insumo);
  }

  function carregarMais() {
    if(!fimLista){
      if(filtroAtivo){
        carregarMovimentacoesFiltrado();
      }
      else{
        carregarMovimentacoesHoje();
      }
    }
  }

  async function abrirDialogAnaliseGeral() {
    try {
      setLoading(true);
      let insumos = [];
      insumosFiltrosSelecionados.map(insumo => {
        insumos.push(insumo.idInsumo);
      });
      const dados = await getEstoqueInsumoMovimentacaoFiltrado(500, 1, undefined, insumos, new Date(filtroDataInicial), new Date(filtroDataFinal), filtroTipoMovimentacaoSelecionado);
      setLoading(false);
      if (dados.isSuccess) {
        if (dados.result.length <= 0) {
          setLoading(false);
          setTypeSnack('warning');
          setMessageSnack('Não foram encontrados dados para o filtro selecionado.');
          setShowMessageSnack(true);
          return;
        }
        setInfoAnaliseDetalhada(dados);
        setOpenDialogAnaliseGeral(true);
      } else {
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(dados.message);
        setShowMessageSnack(true);
      }

    } catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  async function abrirDialogAnaliseResumida() {
    try {
      setLoading(true);
      let insumos = [];
      insumosFiltrosSelecionados.map(insumo => {
        insumos.push(insumo.idInsumo);
      });
      const dados = await getEstoqueInsumoMovimentacaoFiltradoPorInsumo(500, 1, undefined, insumos, new Date(filtroDataInicial), new Date(filtroDataFinal), filtroTipoMovimentacaoSelecionado);
      setLoading(false);
      if (dados.isSuccess) {
        if (dados.result.length <= 0) {
          setLoading(false);
          setTypeSnack('warning');
          setMessageSnack('Não foram encontrados dados para o filtro selecionado.');
          setShowMessageSnack(true);
          return;
        }
        setInfoAnaliseResumida(dados);
        setOpenDialogAnaliseResumida(true);
      } else {
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(dados.message);
        setShowMessageSnack(true);
      }

    } catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  async function abrirDialogAnaliseEstatistica() {
    try {
      setLoading(true);
      let insumos = [];
      insumosFiltrosSelecionados.map(insumo => {
        insumos.push(insumo.idInsumo);
      });
      const dados = await getEstoqueInsumoMovimentacaoFiltradoPorInsumoComMovimentacoes(500, 1, undefined, insumos, new Date(filtroDataInicial), new Date(filtroDataFinal), filtroTipoMovimentacaoSelecionado);
      setLoading(false);
      if (dados.isSuccess) {
        if (dados.result.length <= 0) {
          setLoading(false);
          setTypeSnack('warning');
          setMessageSnack('Não foram encontrados dados para o filtro selecionado.');
          setShowMessageSnack(true);
          return;
        }
        setInfoAnaliseEstatistica(dados);
        setOpenDialogAnaliseEstatistica(true);
      } else {
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(dados.message);
        setShowMessageSnack(true);
      }

    } catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }


  return (
    sucess
    ?
      <BottomScrollListener
        onBottom={e => carregarMais()}
        offset={50}
        debounce={200}
      >
        <Grid
          container
        >
          <Grid
            item
            md={12}
            xs={12}
          >
            <SnackbarCustom
              verticalOrientation='bottom'
              horizontalOrientation='center'
              open={showMessageSnack}
              setOpen={setShowMessageSnack}
              message={messageSnack}
              duration={2000}
              type={typeSnack}
            />
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
          >
            <Dialog open={showDialogAtualizarEstoque} aria-labelledby="form-dialog-title">
              <DialogTitle id="form-dialog-title"> {selectedIndexMovimentacoe < 0 || selectedIndexMovimentacoe >= movimentacoes.result.length ? '' :
                'Atualização de Estoque - ' + movimentacoes.result[selectedIndexMovimentacoe].descricao}
              </DialogTitle>
              <DialogContent>
                <Grid
                  container
                  spacing={2}
                >
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    {
                      <Autocomplete
                        id="combo-box-demo"
                        options={insumos.result}
                        getOptionLabel={option => option.descricao}
                        value={insumoSelecionado}
                        openOnFocus
                        onChange={handleChangeInsumo}
                        renderInput={params =>
                          <TextField
                            {...params}
                            label="Insumo"
                            variant="outlined"
                            fullWidth
                            margin='dense'
                            helperText='Informe o insumo desejado para fazer a movimentação.'
                          />
                        }
                      />
                    }
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <FormControl component="fieldset">
                      <FormLabel component="legend">Tipo de Movimentação</FormLabel>
                      <RadioGroup aria-label="gender" name="gender1" value={radioGroupValue} onChange={handleChange}>
                        <Grid
                          container
                          alignItems={'center'}
                        >
                          <Grid
                            item
                            md={6}
                            xs={6}
                          >
                            <FormControlLabel value="entrada" control={<Radio color="primary"/>} label="Entrada" />
                          </Grid>
                          <Grid
                            item
                            md={6}
                            xs={6}
                          >
                            <FormControlLabel value="saida" control={<Radio color="primary"/>} label="Saída" />
                          </Grid>

                        </Grid>
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Typography
                      gutterBottom
                    >
                      {'Estoque atual: ' + ((insumoSelecionado && insumoSelecionado.estoqueInsumo && insumoSelecionado.estoqueInsumo.quantidade) || 0)}

                    </Typography>
                  </Grid>

                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <TextField
                      type='number'
                      fullWidth
                      label="Quantidade"
                      helperText="Insira o valor a ser decrementado/somado."
                      margin="dense"
                      name="quantidade"
                      onChange={e => setQuantidadeMovimentacao(e.target.value)}
                      value={quantidadeMovimentacao}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Typography
                      gutterBottom
                    >
                      {
                        'Estoque atualizado: ' +
                        ((radioGroupValue === 'entrada' &&
                            (parseInt(((insumoSelecionado && insumoSelecionado.estoqueInsumo && insumoSelecionado.estoqueInsumo.quantidade) || 0)) +
                              parseInt(quantidadeMovimentacao || 0))
                          )
                          ||
                          (radioGroupValue === 'saida' &&
                            (parseInt(((insumoSelecionado && insumoSelecionado.estoqueInsumo && insumoSelecionado.estoqueInsumo.quantidade) || 0)) -
                              parseInt(quantidadeMovimentacao || 0))
                          )
                          ||
                          0)
                      }
                    </Typography>
                  </Grid>

                </Grid>
              </DialogContent>
              <DialogActions>
                <Button onClick={onCancelAtualizarEstoque} color="primary">
                  Cancelar
                </Button>
                <Button onClick={e => atualizarEstoqueMovimentacoe()} color="primary">
                  Confirmar
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
          >
            <ProgressFullScreen
              open={loading}
              setOpen={setLoading}
            />
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
          >
            <DialogAnaliseGeral
              open={openDialogAnaliseGeral}
              setOpen={setOpenDialogAnaliseGeral}
              informacoes={infoAnaliseDetalhada}
              setInformacoes={setInfoAnaliseDetalhada}
              setShowMessageSnack={setShowMessageSnack}
              setMessageSnack={setMessageSnack}
              setTypeSnack={setTypeSnack}
            />
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
          >
            <DialogAnalisePorInsumo
              open={openDialogAnaliseResumida}
              setOpen={setOpenDialogAnaliseResumida}
              informacoes={infoAnaliseResumida}
              setInformacoes={setInfoAnaliseResumida}
              setShowMessageSnack={setShowMessageSnack}
              setMessageSnack={setMessageSnack}
              setTypeSnack={setTypeSnack}
            />
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
          >
            <DialogAnaliseEstatistica
              open={openDialogAnaliseEstatistica}
              setOpen={setOpenDialogAnaliseEstatistica}
              informacoes={infoAnaliseEstatistica}
              setInformacoes={setInfoAnaliseEstatistica}
              setShowMessageSnack={setShowMessageSnack}
              setMessageSnack={setMessageSnack}
              setTypeSnack={setTypeSnack}
            />
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
            className={clsx({
              [classes.margem]: true
            })}
          >
            <EstoqueInsumoMovimentacaoToolbar
              filterMovimentacoes={carregarMovimentacoesFiltrado}
              carregarMovimentacoesMetadadosFiltrado={carregarMovimentacoesMetadadosFiltrado}
              filtroDescricaoInsumo={filtroDescricaoInsumo}
              setFiltroDescricaoInsumo={setFiltroDescricaoInsumo}
              filtroAtivo={filtroAtivo}
              setFiltroAtivo={setFiltroAtivo}
              setPage={setPage}
              insumos={insumos}
              insumosFiltrosSelecionados={insumosFiltrosSelecionados}
              setInsumosFiltrosSelecionados={setInsumosFiltrosSelecionados}
              filtroTipoMovimentacaoSelecionado={filtroTipoMovimentacaoSelecionado}
              setFiltroTipoMovimentacaoSelecionado={setFiltroTipoMovimentacaoSelecionado}
              filtroDataInicial={filtroDataInicial}
              setFiltroDataInicial={setFiltroDataInicial}
              filtroDataFinal={filtroDataFinal}
              setFiltroDataFinal={setFiltroDataFinal}
            />
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
            className={clsx({
              [classes.margem]: true
            })}
          >
            <Alert variant={'outlined'} severity={'info'}>
              As informações acima serão utilizados para filtrar os dados
              contidos nos CARDS abaixo. Clique no CARD que deseja para visualizar as informações de maneira detalhada.
            </Alert>
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
            className={clsx({
              [classes.margem]: true
            })}
          >
            <Grid
              container
              spacing={5}
              >
              <Grid
                item
                md={4}
                xs={12}

              >
                <CardAnaliseGeral
                  valorPrincipal={metadados.qtdMovimentacoes}
                  abrirAnalise={abrirDialogAnaliseGeral}
                />
              </Grid>
              <Grid
                item
                md={4}
                xs={12}

              >
                <CardAnalisePorInsumo
                  valorPrincipal={metadados.qtdInsumosMovimentados}
                  abrirAnalise={abrirDialogAnaliseResumida}
                />
              </Grid>
              <Grid
                item
                md={4}
                xs={12}

              >
                <CardAnaliseEstatistica
                  valorPrincipal={metadados.qtdInsumosMovimentados * 2}
                  abrirAnalise={abrirDialogAnaliseEstatistica}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
            className={clsx({
              [classes.margem]: true
            })}
          >
            <Divider
              style={{
                backgroundColor: Values.cores.corPrimaria
              }}
            />
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
            className={clsx({
              [classes.margem]: true
            })}
          >
            <EstoqueInsumoMovimentacaoTable
              movimentacoes={movimentacoes}
              setMovimentacoes={setMovimentacoes}
              setShowMessageSnack={setShowMessageSnack}
              setMessageSnack={setMessageSnack}
              setTypeSnack={setTypeSnack}
              mensagemSemDados={`Não foram encontradas movimentações para o dia de hoje`}
              titulo={`Movimentações de estoque para o dia ${moment().format('DD/MM/YYYY')}`}
            />
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
            className={classes.divFab}
          >
            <Fab
              aria-label={'Add'}
              className={classes.fab}
              color={'primary'}
              variant={'round'}
              onClick={openMovimentacoeRegister}
            >
              <AddIcon />
            </Fab>
          </Grid>
        </Grid>

      </BottomScrollListener>
      :
      <NotFoundView/>

  );
};

export default EstoqueInsumoMovimentacaoList;
